import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const {
  searchPositionTracker: { getSearchPositionTracker, getSearchPositionTrackerWithoutSKU },
} = apiUrls;

export const SEARCH_POSITION_TRACKER_SUCCESS = 'SEARCH_POSITION_TRACKER_SUCCESS';
export const SEARCH_POSITION_TRACKER_LOADING = 'CUSTOMER_TRANSITION_LOADING';

export const getSearchPositionTrackerData = ({sku, fromDate, toDate }) => async (dispatch) => {
    try {      
      const { urlWithSKU } = getSearchPositionTracker;
      const requestDataWithSKU = {
        ...getSearchPositionTracker,
        url: urlWithSKU.replace('{{sku}}', sku).replace('{{fromdate}}', fromDate).replace('{{todate}}', toDate),
      };   
      
      const { urlWithOutSKU } = getSearchPositionTrackerWithoutSKU;
      const requestDataWithoutSKU = {
        ...getSearchPositionTracker,
        url: urlWithOutSKU.replace('{{fromdate}}', fromDate).replace('{{todate}}', toDate),
      };
      const data = await REQUEST(sku ? requestDataWithSKU : requestDataWithoutSKU);
      dispatch({
        type: SEARCH_POSITION_TRACKER_SUCCESS,
        data,
      });
    } catch (e) {
      dispatch({
        type: SEARCH_POSITION_TRACKER_SUCCESS,
        data: {
          code: '',
          modal: null,
          notifications: null,
          paginationInfo: null,
        },
      });
    }
  };

export const handleLoader = isLoading => (dispatch) => {
  dispatch({
    type: SEARCH_POSITION_TRACKER_LOADING,
    isLoading,
  });
};
